import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management_user" },
  { title: "menu_sidebar_management_user_partner_b2b_user", link: "management/user/partner-b2b-user" }
];

const PartnerB2BUserAdd = Loadable({
  loader: () => import("container/management/user/partnerB2BUser"),
  loading() {
    return <Loader />;
  }
});

const PartnerB2BUserListing = Loadable({
  loader: () => import("container/management/user/partnerB2BUser/listing"),
  loading() {
    return <Loader />;
  }
});

export const partnerB2BUserRoutes: IRoute[] = [
  {
    path: "/management/user/partner-b2b-user",
    element: <PartnerB2BUserListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/management/user/partner-b2b-user/details/:id?",
    element: <PartnerB2BUserAdd />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
